<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>work</mat-icon></div>
          <mat-card-title>
            Cargo
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
            <div class="col-12 col-md-1">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>ID</mat-label>
                <input matInput formControlName="id" readonly>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nome" required>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Departamento</mat-label>
                <mat-select formControlName="departamentoId" required>
                  <mat-option *ngFor="let d of departamentos" [value]="d.id">{{ d.nome }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Situação</mat-label>
                <mat-select formControlName="ativo">
                  <mat-option [value]="true">Ativo</mat-option>
                  <mat-option [value]="false">Inativo</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Descrição</mat-label>
                <textarea matInput formControlName="descricao" rows="3"></textarea>
              </mat-form-field>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button (click)="limpar()">
              <mat-icon>clear</mat-icon> Limpar
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
